// Change this string to match your actual backend server URL
export const API_URL = 'https://api.tf-mephi-raspisanie.uz';
